var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _circle2, _path23, _g2, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 280 165",
    enableBackground: "new 0 0 280 165",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F4",
    d: "M-163.314,88.204l326.582-326.582L480.254,78.609L153.672,405.191L-163.314,88.204z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#83CDAC",
    d: "M180.113,119.055l33.649-33.649l47.722,47.722l-33.65,33.649L180.113,119.055z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F4",
    d: "M180.61,51.092l56.458-56.458l34.314,34.314l-56.458,56.458L180.61,51.092z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8AD0FF",
    d: "M17.93,139.459l45.932-45.932l36.231,36.231L54.161,175.69L17.93,139.459z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#83CDAC",
    d: "M236.706,63.189l51.685-51.685l24.601,24.601L261.307,87.79L236.706,63.189z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M73.336,84.398l1.414-1.414l200.575,200.575l-1.414,1.414L73.336,84.398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M168.306,63.936l1.414-1.414l33.47,33.47l-1.414,1.414L168.306,63.936z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M123.968-199.119l1.414-1.414l317.011,317.011l-1.414,1.414L123.968-199.119z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M-78.043,2.886l1.414-1.414L38.436,116.537l-1.414,1.414L-78.043,2.886z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M41.018,292.597l156.98-156.981l1.414,1.414L42.432,294.011L41.018,292.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M175.086,300.368L438.547,36.907l1.414,1.414L176.5,301.782L175.086,300.368z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M96.279,347.859L422.891,21.247l1.414,1.414L97.694,349.273L96.279,347.859z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M209.643,23.695l1.414-1.414l33.28,33.28l-1.414,1.414L209.643,23.695z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M-18.433-56.724l1.414-1.414l95.747,95.747l-1.414,1.414L-18.433-56.724z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M-65.023-10.136l1.414-1.414l76.394,76.394l-1.414,1.414L-65.023-10.136z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-69.364,182.227l326.648-326.648l3.535,3.535L-65.829,185.762L-69.364,182.227z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.391,273.97l326.64-326.64l3.535,3.535l-326.64,326.64L22.391,273.97z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M9.125,260.702L199.12,70.706l1.414,1.414L10.539,262.116L9.125,260.702z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M-87.688,163.914L238.966-162.74l1.414,1.414L-86.274,165.328L-87.688,163.914z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M90.084,115.51l43.808-43.808l1.414,1.414l-43.808,43.808L90.084,115.51z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M48.599,300.152l326.62-326.619l3.535,3.535L52.134,303.687L48.599,300.152z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#93D8B7",
    d: "M207.068,141.339l28.47-28.469l3.897,3.897l-28.47,28.469L207.068,141.339z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M128.021,69.365l3.535-3.535l180.749,180.749l-3.535,3.535L128.021,69.365z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M23.794-98.963l5.657-5.657l317.017,317.017l-5.657,5.657L23.794-98.963z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M104.759,81.878c-9.793,0-17.894-3.996-22.398-7.789l-0.252-0.231L-33.461-41.713l5.657-5.656L87.623,68.058 c1.761,1.401,20.604,15.461,42.108-6.039l167-167.001l5.657,5.656l-167,167.001C124.743,78.32,113.998,81.878,104.759,81.878 L104.759,81.878z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M236.132,64.994l3.535-3.535l128.88,128.88l-3.535,3.535L236.132,64.994z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEE379",
    d: "M-51.009,200.582l326.602-326.695l5.658,5.656L-45.351,206.238L-51.009,200.582z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEE379",
    d: "M-126.899,124.696l326.602-326.695l5.658,5.656l-326.602,326.695L-126.899,124.696z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEE379",
    d: "M69.996,321.581L396.598-5.114l5.658,5.656L75.653,327.237L69.996,321.581z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-11.713,239.881L314.936-86.768l3.535,3.535L-8.178,243.415L-11.713,239.881z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEE379",
    d: "M-55.806-19.366l5.657-5.657l317.017,317.017l-5.657,5.657L-55.806-19.366z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEE379",
    d: "M-103.454,28.281l5.657-5.657L219.22,339.641l-5.657,5.657L-103.454,28.281z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FEE379",
    cx: 84.49,
    cy: 70.703,
    r: 13.053
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 84.49,
    cy: 70.703,
    r: 4.473
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEE379",
    d: "M76.084,67.833L-33.461-41.713l5.657-5.656L81.598,62.033L76.084,67.833z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E44746",
    d: "M157.428,76.01c0-10.264-8.873-18.455-19.366-17.322c-8.287,0.894-14.642,7.359-15.41,15.659 c-0.509,5.266,1.408,10.477,5.208,14.158c1.413,1.372,2.729,2.842,3.937,4.398c3.4,4.376,5.68,9.514,6.885,14.922l0.982,4.404 h0.673l1.02-4.568c1.185-5.32,3.395-10.392,6.724-14.708c1.162-1.511,2.444-2.926,3.833-4.231 C155.437,85.433,157.434,80.829,157.428,76.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M145.403,77.381c0,2.984-2.419,5.402-5.403,5.402s-5.402-2.419-5.402-5.403s2.419-5.402,5.402-5.402 S145.403,74.396,145.403,77.381"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEE379",
    d: "M109.642-184.808l5.657-5.657l317.017,317.017l-5.657,5.657L109.642-184.808z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.739bfaed8fb109c97ed162484ecf221e.svg";
export { ForwardRef as ReactComponent };